import { useEffect, useState } from 'react';
import { CreateGroupRequest, FetchPostParams, GroupDatas, GroupElement, UserElement } from '../../models';
import { groupService } from '../../services/group.service';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export const useGroupHook = ({
  pageNumber,
  groupId,
  pageMemberNumber,
  pageMemberRequestNumber,
  isRefetch,
}: {
  pageNumber?: number;
  groupId?: string;
  pageMemberNumber?: number;
  pageMemberRequestNumber?: number;
  isRefetch?: boolean;
}) => {
  const [groups, setGroups] = useState<GroupDatas[]>([]);
  const [groupPermission, setGroupPermission] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [group, setGroup] = useState<GroupElement | null>(null);
  const [users, setUser] = useState<UserElement[]>([]);
  const [memberRequest, setMemberRequest] = useState<UserElement[]>([]);
  const navigate = useNavigate();
  const appendNewGroup = async (newGroup: CreateGroupRequest) => {
    try {
      const { data } = await groupService.createGroup(newGroup);
      if (data) {
        toast.success('Tạo nhóm thành công');
        navigate(`/group/${data}`);
        setGroups((prev) => [data, ...prev]);
      }
    } catch {
      toast.error('Tạo nhóm thất bại');
    }
  };
  const updateGroup = async (data: CreateGroupRequest, groupId: any) => {
    try {
      if (groupId) {
        const res = await groupService.updateGroup(data, groupId);
        toast.success('Câp nhật nhóm thành công');
        getGroupDetail(groupId);
      }
    } catch {
      toast.error('cập nhật nhóm thất bại');
    }
  };

  const getGroups = async (payload: FetchPostParams) => {
    try {
      setLoading(true);
      const { data } = await groupService.getGroup(payload);
      setGroups(data.elements);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  const getGroupDetail = async (id: string) => {
    try {
      const { data } = await groupService.getGroupDetail(id);
      setGroup(data);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  const getGroupPermission = async (id: string) => {
    try {
      const { data } = await groupService.getGroupPermission(id);
      setGroupPermission(data);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  const getGroupMembers = async (id: string, payload: FetchPostParams) => {
    try {
      const { data } = await groupService.getGroupMembers(id, payload);
      setUser(data?.elements);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  const getGroupMemberRequest = async (id: string, payload: FetchPostParams) => {
    try {
      const { data } = await groupService.getGroupMemberRequest(id, payload);
      setMemberRequest(data?.elements);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    groupId && getGroupDetail(groupId);
    groupId && getGroupPermission(groupId);
    groupId && getGroupMembers(groupId, { pageNumber: pageMemberNumber, pageSize: 10 });
    groupId && getGroupMemberRequest(groupId, { pageNumber: pageMemberRequestNumber, pageSize: 10 });
  }, [groupId, isRefetch]);

  useEffect(() => {
    // Chỉ tải danh sách nhóm khi có pageNumber. Caller không cần list (vd modal tạo nhóm gọi
    // useGroupHook({})) sẽ để pageNumber=undefined → tránh gọi get-list-group?pageNumber=undefined
    // (API trả 400 → FE cố iterate lỗi → crash trang /group).
    if (pageNumber == null) return;
    getGroups({
      pageNumber,
      pageSize: 10,
    });
  }, [pageNumber, isRefetch]);

  return {
    data: groups,
    loading,
    detail: group,
    appendNewGroup,
    permission: groupPermission,
    members: users,
    memberRequest,
    updateGroup,
  };
};
